// Client-side action logger — отправляет batch UI-событий на /api/_actions/ingest.
// Для self-investigation: я (Claude) расследую UX-баги через timeline действий пользователя
// без необходимости видеть его экран.
import { getSessionId } from './session';

interface QueuedAction {
  eventType: string;
  entity?: string;
  entityId?: string;
  payload?: unknown;
  durationMs?: number;
  sessionId: string;
  ts: number;
}

const BATCH_SIZE = 20;
const FLUSH_INTERVAL_MS = 3000;
const MAX_QUEUE = 500;

const queue: QueuedAction[] = [];
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function scheduleFlush() {
  if (queue.length >= BATCH_SIZE) {
    flush();
    return;
  }
  if (flushTimer) return;
  flushTimer = setTimeout(flush, FLUSH_INTERVAL_MS);
}

async function flush() {
  if (flushTimer) {
    clearTimeout(flushTimer);
    flushTimer = null;
  }
  if (queue.length === 0) return;
  const batch = queue.splice(0, BATCH_SIZE);
  try {
    const res = await fetch('/api/_actions/ingest', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ actions: batch }),
      keepalive: true,
    });
    if (!res.ok) {
      queue.unshift(...batch);
      flushTimer = setTimeout(flush, FLUSH_INTERVAL_MS * 2);
    }
  } catch {
    queue.unshift(...batch);
    flushTimer = setTimeout(flush, FLUSH_INTERVAL_MS * 2);
  }
}

export function logAction(
  eventType: string,
  details?: { entity?: string; entityId?: string; payload?: unknown; durationMs?: number },
) {
  if (queue.length >= MAX_QUEUE) return;
  queue.push({
    eventType,
    entity: details?.entity,
    entityId: details?.entityId,
    payload: details?.payload,
    durationMs: details?.durationMs,
    sessionId: getSessionId(),
    ts: Date.now(),
  });
  scheduleFlush();
}

// Flush на закрытии вкладки
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    if (queue.length > 0) {
      try {
        navigator.sendBeacon(
          '/api/_actions/ingest',
          new Blob([JSON.stringify({ actions: queue.splice(0) })], { type: 'application/json' }),
        );
      } catch {
        /* ignore */
      }
    }
  });
}
